import script from "./AdminStats.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStats.vue?vue&type=script&setup=true&lang=js"

import "./AdminStats.vue?vue&type=style&index=0&id=7c917cd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c917cd2"]])

export default __exports__